import { Badge } from "@/components/ui/badge";

export const money = (n) => `${Number(n) < 0 ? "-" : ""}₹${Math.abs(Number(n || 0)).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-IN") : "—");

// Balance = Advances − Bills. Positive: employee still holds money; negative: company owes employee.
export function BalanceLabel({ balance, testId, large }) {
  const b = Number(balance || 0);
  const size = large ? "text-2xl" : "text-base";
  if (b > 0) {
    return (
      <div data-testid={testId}>
        <div className={`${size} font-bold text-amber-700`}>{money(b)}</div>
        <div className="text-xs text-amber-700">Employee holds {money(b)} unaccounted</div>
      </div>
    );
  }
  if (b < 0) {
    return (
      <div data-testid={testId}>
        <div className={`${size} font-bold text-rose-700`}>{money(Math.abs(b))}</div>
        <div className="text-xs text-rose-700">Employee is owed {money(Math.abs(b))}</div>
      </div>
    );
  }
  return (
    <div data-testid={testId}>
      <div className={`${size} font-bold text-emerald-700`}>{money(0)}</div>
      <div className="text-xs text-emerald-700">Nothing outstanding</div>
    </div>
  );
}

export const StatusBadge = ({ status, testId }) => (
  <Badge data-testid={testId} className={status === "Settled" ? "bg-emerald-600" : "bg-amber-500"}>{status}</Badge>
);
